import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { NodeData } from 'store';

@Component
export default class NavigationSectionHeader extends Vue {
	@Prop({
		default() {
			return {};
		}
	})
	item!: NodeData;

	@Prop({
		default: false
	})
	isActive!: boolean;

	@Prop({
		default: false
	})
	isAvailable!: boolean;

	@Emit('header:clicked')
	handleHeaderClick() {}
}
